import { useEmpresaServicos } from '@/api/queries/empresa';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Skeleton } from '@/components/ui/skeleton';

export function TabServicos({ empresaId }: { empresaId: string }) {
  const { data, isLoading } = useEmpresaServicos(empresaId);
  if (isLoading) return <Skeleton className="h-48 mt-4" />;
  if (!data || data.length === 0) {
    return <p className="text-muted-foreground mt-4">Nenhum serviço fit ainda.</p>;
  }
  return (
    <div className="space-y-3 mt-4">
      {data.map((s) => (
        <Card key={s.id} className="p-4 flex items-center gap-4">
          <div className="flex-1">
            <div className="flex items-center gap-2">
              <span className="font-medium">{s.servico.nome}</span>
              <Badge variant={s.manual_ou_auto === 'auto' ? 'secondary' : 'default'}>
                {s.manual_ou_auto}
              </Badge>
            </div>
            {s.servico.descricao_curta && (
              <p className="text-sm text-muted-foreground">{s.servico.descricao_curta}</p>
            )}
            {s.justificativa && <p className="text-sm mt-1">{s.justificativa}</p>}
          </div>
          <div className="text-right">
            <div className="text-2xl font-semibold">{s.fit_score}</div>
            <div className="text-xs text-muted-foreground">fit-score</div>
          </div>
        </Card>
      ))}
    </div>
  );
}
